<template>
  <p-selection-parent
    :mandatory="mandatory"
    :multiple="multiple"
    :value="selected"
    active-class="active"
    class="p-list-group"
    @input="$emit('input', $event)"
  >
    <p-accordion-group v-if="!_.component.hasSlot(this, 'activator')">
      <slot></slot>
    </p-accordion-group>
    <template v-else>
      <li>
        <p-accordion v-model="isExpanded">
          <template #expander="{expanded}">
            <p-list-entry
              :class="{active: expanded}"
              :color="color"
              :tag="tag"
              :icon-left="iconLeft"
              :icon-right="iconRight"
              @click="onExpanderClick"
            >
              <slot name="activator" :expanded="expanded"></slot>
              <p-icon>
                {{ expanded ? 'expand_less' : 'expand_more' }}
              </p-icon>
            </p-list-entry>
          </template>
          <p-accordion-group>
            <p-list>
              <slot></slot>
            </p-list>
          </p-accordion-group>
        </p-accordion>
      </li>
    </template>
  </p-selection-parent>
</template>

<script lang="ts">
  import mixins from '../../mixins';

  export default mixins().extend({
    props: {
      value: { default: undefined, type: undefined },
      multiple: { default: false, type: Boolean },
      mandatory: { default: false, type: Boolean },
      iconLeft: { default: undefined, type: String },
      iconRight: { default: undefined, type: String },
      color: { default: undefined, type: String },
      tag: { default: 'div', type: String },
    },
    watch: {
      value: {
        immediate: true,
        handler() {
          this.selected = this.value;
        },
      },
    },
    methods: {
      onExpanderClick() {
        this.$emit('click');
      },
    },
    data: () => ({
      selected: undefined as any,
      isExpanded: false,
    }),
  });
</script>
